<template>
  <div class="container-fluid pt-0 mt-0">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>

    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-6">
        <IconCard
          :label="$t('all-orders')"
          :title="`${orderSummary.all}`"
          :iconColor="'background-color: rgba(222, 234, 242, 0.3);'"
        >
          <template slot="icon">
            <img src="../../assets/images/Check All.svg" />
          </template>
        </IconCard>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6">
        <IconCard
          :label="$t('pending-orders')"
          :title="`${orderSummary.new}`"
          iconColor="background-color: rgba(218, 236, 224, 0.3);"
        >
          <template slot="icon">
            <img src="../../assets/images/Data Pending.svg" />
          </template>
        </IconCard>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6">
        <IconCard
          :label="$t('completed-orders')"
          :title="`${orderSummary.completed}`"
          iconColor="background-color: rgba(248, 235, 206, 0.3);"
        >
          <template slot="icon">
            <img src="../../assets/images/Checked Checkbox.svg" />
          </template>
        </IconCard>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6">
        <IconCard
          :label="`${$t('cancelled-orders')}`"
          :title="`${orderSummary.cancelled}`"
          iconColor="background-color: rgba(248, 226, 227, 0.3);"
        >
          <template slot="icon">
            <img src="../../assets/images/info.svg" />
          </template>
        </IconCard>
      </div>
    </div>

    <div
      style="
        background-color: #fff;
        max-height: 40rem;
        overflow-y: auto;
        width: 100%;
        height: fit-content;
        margin-top: 1rem;
      "
    >
      <div class="card-body" style="overflow-x: auto; width: 100%">
        <div
          class="header d-flex justify-content-between align-items-center"
          style="margin-bottom: 1rem"
        >
          <div class="selectDiv">
            <select id="dropdown" v-model="selectedOption">
              <option
                v-for="option in getOptions"
                :key="option.value"
                :value="option.value"
                class="text-capitalize"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
          <TableSearch @handleSearch="handleSearch" />
        </div>

        <div class="row">
          <div class="col-md-12">
            <div ref="content" class="table-responsive">
              <table id="order-listing" class="table table-hover display">
                <thead style="background-color: rgba(240, 244, 251, 0.6)">
                  <tr>
                    <th
                      :key="index"
                      v-for="(column, index) in tableColumns"
                      @click="sortBy(column[1])"
                      style="cursor: pointer; text-align: left"
                    >
                      {{ column[0] }}
                      <span
                        class="arrow"
                        :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                      ></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :key="index"
                    v-for="(order, index) in paginatedData"
                    style="border-bottom: unset"
                    :class="{
                      'data-table-bg': index % 2 !== 0,
                    }"
                    @click="viewOrder(order.id)"
                    class="cursor-pointer"
                  >
                    <td>{{ order.orderReference }}</td>
                    <td>{{ order.dropoffs.length }}</td>
                    <td> {{ order.driver ? "Driver" : "Partner" }} </td>
                    <td>{{ formatDate(order.startedAt) }}</td>
                    <td>{{ formatDate(order.completedAt) }}</td>
                    <td>
                      <span class="two status text-capitalize">
                        <span :class="`circle ${order.status}`"></span>
                        {{ orderStatus(order.status) }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination
              :pageCount="pageCount"
              :data="paginatedData"
              :sizeperpage="sizeperpage"
              :pageNumber="pageNumber"
              :pages="pages"
              @goToLastPage="goToLastPage"
              @nextPage="nextPage"
              @handlePageChange="handlePageChange"
              @goToFirstPage="goToFirstPage"
              @prevPage="prevPage"
              @onchange="onchange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import tableMixin from "../../mixins/tableMixinWithBackend";
import Pagination from "../../components/PaginationNew.vue";
import TableSearch from "../../components/TableSearch.vue";
import { mapActions, mapGetters } from "vuex";
import IconCard from "../../components/IconCard.vue";
import moment from "moment";

export default {
  name: "DispatchOverview",

  components: {
    Loading,
    Pagination,
    TableSearch,
    IconCard,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      Tag: "",
      dataTable: [],
      selectedOption: "",
    };
  },
  methods: {
    ...mapActions(["getOrders", "getOrderSummary"]),
    doSearch() {
      let params = {
        ...this.params,
        status: this.selectedOption ? [this.selectedOption] : undefined,
        filterOperator: "and",
        keyword: this.searchQuery,
      };
      this.fetchOrders(params);
    },
    fetchOrders(params) {
      this.isLoading = true;
      this.getOrders(params)
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    viewOrder(id) {
      this.$router.push(`/dispatch/order/${id}`);
    },
    orderStatus(status) {
      let orderStatus = "";
      if (status === "new") {
        orderStatus = this.$t("new_new");
      } else if (status === "in_progress") {
        orderStatus = this.$t("in_progress");
      } else if (status === "completed") {
        orderStatus = this.$t("completed");
      } else if (status === "cancelled") {
        orderStatus = this.$t("cancelled");
      }
      return orderStatus;
    },
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY HH:mmA") : "-";
    },
  },
  created() {
    this.fetchOrders(this.params);
    this.getOrderSummary();
  },
  mixins: [tableMixin],
  computed: {
    ...mapGetters(["orders", "ordersMeta", "orderSummary"]),

    paginationMeta() {
      return this.meta;
    },
    tableColumns() {
      return [
        [this.$t("order-id"), "order-id"],
        [this.$t("No of Drop off"), "no-of-drop-off"],
        [this.$t("Driver/Partner"), "driver-partner"],
        [this.$t("start-date"), "start-date"],
        [this.$t("end-date"), "enddate"],
        [this.$t("status"), "status"],
      ];
    },
    getOptions() {
      return [
        { value: "", text: this.$t("all-orders") },
        { value: "new", text: this.$t("pending-orders") },
        { value: "completed", text: this.$t("completed-orders") },
        { value: "cancelled", text: this.$t("cancelled-orders") },
      ];
    },
  },
  watch: {
    orders: {
      handler: function () {
        this.dataTable = this.orders;
      },
      deep: true,
    },
    params() {
      this.fetchOrders(this.params);
    },
    selectedOption() {
      this.doSearch();
    },
  },
};
</script>

<style scoped>
.cards {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  gap: 1rem;
}

.card {
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  max-width: 100%;
  height: 130px;
}

.icon-wrapper {
  height: 60px;
  width: 60.9px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
}

.icon-1 {
  background-color: rgba(222, 234, 242, 1);
}

.icon-2 {
  background-color: rgba(218, 236, 224, 1);
}

.icon-3 {
  background-color: rgba(248, 235, 206, 1);
}

.icon-4 {
  background-color: rgba(248, 226, 227, 1);
}

.text {
  width: 120px;
  display: flex;
  flex-direction: column;
}

.text > .one {
  font-weight: 800;
  font-size: 22px;
}

.text > .two {
  font-size: 14px;
  font-weight: 400;
}

.selectDiv {
  width: 225px;
  height: 44px;
  border-radius: 10px;
  border: 2px solid rgba(163, 171, 185, 0.1);
}

select {
  width: 200px;
  background: none !important;
  font-size: 14px !important;
  font-weight: 500;
  color: rgba(64, 74, 87, 1);
  background-color: beige;
}

.select-selected:after {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.two.status {
  display: flex;
  align-items: center;
}

.circle {
  margin-left: 4px;
  margin-right: 6px;
  height: 10px;
  width: 10px;
  border-radius: 100%;
  display: inline-block;
}

.new {
  background-color: #e4a97a;
}

.completed {
  background-color: #28a84a;
}

.in_progress {
  background-color: #f3c963;
}

.cancelled {
  background-color: #dc3030;
}

@media (max-width: 767px) {
  .cards {
    flex-direction: column;
  }

  .card {
    width: 500px;
  }

  .header {
    gap: 0.4rem;
  }

  .selectDiv {
    width: 170px;
  }

  select {
    width: 160px;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .card {
    flex: 0 1 auto;
    width: 350px;
  }
}
</style>

<i18n>
  {
    "en": {
      "all-orders": "All Orders",
      "pending-orders": "Pending Orders",
      "completed-orders": "Completed Orders",
      "cancelled-orders": "Cancelled Orders",
      "order-id": "Order ID",
      "receiver-name": "Receiver's Name",
      "driver-partner": "Driver/Partner",
      "start-date": "Start Date",
      "end-date": "End Date",
      "status": "Status"
    },
    "es": {
    "all-orders": "Todas las órdenes",
    "pending-orders": "Órdenes pendientes",
    "completed-orders": "Órdenes completadas",
    "cancelled-orders": "Órdenes canceladas",
    "order-id": "ID de orden",
    "receiver-name": "Nombre del receptor",
    "driver-partner": "Conductor/Socio",
    "start-date": "Fecha de inicio",
    "end-date": "Fecha de finalización",
    "status": "Estado"
    },
    "fr": {
    "all-orders": "Toutes les commandes",
    "pending-orders": "Commandes en attente",
    "completed-orders": "Commandes terminées",
    "cancelled-orders": "Commandes annulées",
    "order-id": "ID de commande",
    "receiver-name": "Nom du destinataire",
    "driver-partner": "Chauffeur/Partenaire",
    "start-date": "Date de début",
    "end-date": "Date de fin",
    "status": "Statut"
    },
    "sw": {
    "all-orders": "Maagizo yote",
    "pending-orders": "Maagizo yanayosubiri",
    "completed-orders": "Maagizo yaliyokamilika",
    "cancelled-orders": "Maagizo yaliyofutwa",
    "order-id": "ID ya agizo",
    "receiver-name": "Jina la mpokeaji",
    "driver-partner": "Dereva/Mshirika",
    "start-date": "Tarehe ya kuanza",
    "end-date": "Tarehe ya kumaliza",
    "status": "Hali"
    }
  }
  </i18n>
